import React, { FC, useContext } from 'react'
import { ReviewDetailContext } from '../../../contexts/ReviewDetailProvider'
import ReviewDetail from '.'

const ReviewDetailContainer: FC = () => {
  const { review, loading } = useContext(ReviewDetailContext)

  if (!review && !loading) return null

  return <ReviewDetail />
}

export default ReviewDetailContainer
